import axios from 'axios';
import $ from 'jquery';
import receiveContext from './ReceiveContext';
import messages from '../statics/messages.json';
import { useNavigate } from 'react-router-dom';
import { dropUnmatchedBooleanWorkflowHistory, filterOrderHistoryEntries } from '../Components/orderHistory/orderHistoryFilter';
import { applyOrderAccessHistoryHints } from '../Components/orderHistory/orderAccessHistoryHints';

const navigate = useNavigate;

export const getParts = async (index, maxRecords) => {
    try {
        debugger
        // Check if running locally
    const isLocal = window.location.hostname === "localhost";

    // Get port from config for local, empty for production
    const port = isLocal ? messages.node_server_port : "";

    // Build the base URL
    const contextPath = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;
        // const contextPath = `${window.location.protocol}//${window.location.hostname}:${messages.node_server_port}`;
        const url = `${contextPath}/receivingService/getParts`;
        const response = await axios.get(url, {
            params: { index, maxRecords },
            withCredentials: true,
        });

        if (response.status !== 200 || !response.data) {
            throw new Error(`Invalid response with status: ${response.status}`);
        }

        return response.data;
    } catch (err) {
        console.error('Error fetching parts:', err.message);
                if(err.status === 401){
                localStorage.removeItem('jwt');
                navigate('/login');
            }
            console.error("Fetch error:", err);
        return { parts: [], totalRecords: 0 }; // Return fallback to avoid crashes

    }
};

export const handleConnectClick = async () => {
    // const clientId = '1000.B9MIBKQY1CQ5ONQVPS0V5PKVPXHK9M';
    // const redirectUri = 'http://localhost:5000/oauth2/callback'; 
    // const scope = 'ZohoBigin.modules.READ ZohoBigin.modules.CREATE ZohoBigin.modules.UPDATE ZohoBigin.modules.DELETE';
    // const authUrl = `https://accounts.zoho.com/oauth/v2/auth?scope=${scope}&client_id=${clientId}&response_type=code&access_type=offline&redirect_uri=${redirectUri}`;
    
    // // Redirect to Zoho OAuth URL
    // window.location.href = authUrl;
    debugger
    const contextPath = `${window.location.protocol}//${window.location.hostname}:${messages.node_server_port}`;
    const url = `${contextPath}/oauth2/zohoauthenticationURL`;
    const response = await axios.get(url);

    window.location.href = response.data;
};

export const contacts = async (index,maxRecords,sync,module,searchTerm) => {
    try{
       debugger
       // Check if running locally
    const isLocal = window.location.hostname === "localhost";

    // Get port from config for local, empty for production
    const port = isLocal ? messages.node_server_port : "";

    // Build the base URL
    const contextPath = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;
        // const contextPath = `${window.location.protocol}//${window.location.hostname}:${messages.node_server_port}`;
        const url = `${contextPath}/api/customers`;
        const response = await axios.get(url, {
            params: { index, maxRecords,sync,module,searchTerm },
            withCredentials: true,
        });

        if (response.status !== 200 || !response.data) {
            return null;
        }

        return response.data;
    } catch (err) {
                if(err.status === 401){
                localStorage.removeItem('jwt');
                navigate('/login');
            }
            console.error("Fetch error:", err);
        return { parts: [], totalRecords: 0 }; // Return fallback to avoid crashes
    }
};

export const POPartsData = async(search,status,sortColumn,sortDirection)=>{
    try {
        debugger
        const { productionDetailsFeatch, VendorFeatch } = receiveContext();
        const data = await productionDetailsFeatch('0','10',search,status,sortColumn,sortDirection);
        return data;
    } catch (err) {
          if(err.status === 401){
                localStorage.removeItem('jwt');
                navigate('/login');
            }
            console.error("Fetch error:", err);
    }
}

export const SearchPOData = async(search,status,sortColumn,sortDirection)=>{
    try {
        debugger
        // Check if running locally
    const isLocal = window.location.hostname === "localhost";

    // Get port from config for local, empty for production
    const port = isLocal ? messages.node_server_port : "";

    // Build the base URL
    const contextPath = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;
        // const contextPath = `${window.location.protocol}//${window.location.hostname}:${messages.node_server_port}`;
        const url = `${contextPath}/api/searchPO`;
        const data = await axios.get(url,{
            params: {search },
            withCredentials: true,
        });
        if(data.status === 200)
        return data.data;
        else
            return null;

    } catch (err) {
          if(err.status === 401){
                localStorage.removeItem('jwt');
                navigate('/login');
            }
            console.error("Fetch error:", err);
            return null;
    }
}

export const SearchVendorData = async(search,status,sortColumn,sortDirection)=>{
    try {
        debugger
        // Check if running locally
    const isLocal = window.location.hostname === "localhost";

    // Get port from config for local, empty for production
    const port = isLocal ? messages.node_server_port : "";

    // Build the base URL
    const contextPath = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;
        // const contextPath = `${window.location.protocol}//${window.location.hostname}:${messages.node_server_port}`;
        const url = `${contextPath}/api/searchVendor`;
        const data = await axios.get(url,{
            params: {search },
            withCredentials: true,
        });
        if(data.status === 200)
        return data.data;
        else
            return null;

    } catch (err) {
          if(err.status === 401){
                localStorage.removeItem('jwt');
                navigate('/login');
            }
            console.error("Fetch error:", err);
    }
}

export const getStatus = async()=>{
    try {
        debugger
        // Check if running locally
    const isLocal = window.location.hostname === "localhost";

    // Get port from config for local, empty for production
    const port = isLocal ? messages.node_server_port : "";

    // Build the base URL
    const contextPath = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;
        // const contextPath = `${window.location.protocol}//${window.location.hostname}:${messages.node_server_port}`;
        const url = `${contextPath}/api/getStatus`;
        const data = await axios.get(url,{withCredentials: true});
        if(data.status === 200)
            return data.data;
        else
            return null;

    } catch (err) {
          if(err.status === 401){
                localStorage.removeItem('jwt');
                navigate('/login');
            }
            console.error("Fetch error:", err);
    }
}

export const getShipmentMethods = async(search)=>{
    try {
        debugger
        // Check if running locally
    const isLocal = window.location.hostname === "localhost";

    // Get port from config for local, empty for production
    const port = isLocal ? messages.node_server_port : "";

    // Build the base URL
    const contextPath = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;
        // const contextPath = `${window.location.protocol}//${window.location.hostname}:${messages.node_server_port}`;
        const url = `${contextPath}/api/getShipmentMethods`;
        const data = await axios.get(url,{
            params: {search },
            withCredentials: true,
        });
        if(data.status === 200)
            return data.data;
        else
            return null;

    } catch (err) {
        if(err.status === 401){
                localStorage.removeItem('jwt');
                navigate('/login');
            }
            console.error("Fetch error:", err);
    }
}

export const getCountries = async(search)=>{
    try {
        debugger
        // Check if running locally
    const isLocal = window.location.hostname === "localhost";

    // Get port from config for local, empty for production
    const port = isLocal ? messages.node_server_port : "";

    // Build the base URL
    const contextPath = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;
        // const contextPath = `${window.location.protocol}//${window.location.hostname}:${messages.node_server_port}`;
        const url = `${contextPath}/api/getCountries`;
        const data = await axios.get(url,{
            params: {search },
            withCredentials: true,
        });
        if(data.status === 200)
            return data.data;
        else
            return null;

    } catch (err) {
        if(err.status === 401){
                localStorage.removeItem('jwt');
                navigate('/login');
            }
            console.error("Fetch error:", err);
    }
}

export const getCustomer = async(search)=>{
    try {
        debugger
        // Check if running locally
    const isLocal = window.location.hostname === "localhost";

    // Get port from config for local, empty for production
    const port = isLocal ? messages.node_server_port : "";

    // Build the base URL
    const contextPath = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;
        // const contextPath = `${window.location.protocol}//${window.location.hostname}:${messages.node_server_port}`;
        const url = `${contextPath}/api/getCustomer`;
        const data = await axios.get(url,{
            params: {search },
            withCredentials: true,
        });
        if(data.status === 200)
            return data.data;
        else
            return null;

    } catch (err) {
        if(err.status === 401){
                localStorage.removeItem('jwt');
                navigate('/login');
            }
            console.error("Fetch error:", err);
    }
}

const toMentionUser = (item) => {
    if (typeof item === 'string') {
        const email = item;
        const username = email.split('@')[0] || email;
        return { username, email, displayName: '', department: '' };
    }
    const email = item?.email || '';
    const username = item?.username || (email && email.split('@')[0]) || item?.name || '';
    const named = String(item?.displayName || item?.name || '').trim();
    return {
        username,
        email,
        displayName: named && !named.includes('@') ? named : '',
        department: item?.department || item?.dept || '',
    };
};

export const getUsers = async (search) => {
    try {
        // Check if running locally
        const isLocal = window.location.hostname === "localhost";
        const port = isLocal ? messages.node_server_port : "";
        const contextPath = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;

        // Primary: call the endpoint you showed (returns an array of emails)
        // Example: GET /users/findByEmails?serach=a  -> ["user1@...","user2@..."]
        try {
            const url = `${contextPath}/api/users/findByEmails`;
            // Note: your example used the query param name `serach` (typo). Use it here
            // so this client matches the current backend. If backend supports `search`,
            // it will still work in the fallback below.
            const response = await axios.get(url, { params: { serach: search }, withCredentials: true });
            if (response.status === 200 && Array.isArray(response.data)) {
                return response.data.map(toMentionUser);
            }
        } catch (innerErr) {
            // Continue to fallback if this endpoint is not available or fails
            console.warn('findByEmails lookup failed, falling back to /api/getUsers', innerErr?.message || innerErr);
        }

        // Fallback: older API that returns richer objects (keep compatibility)
        const url2 = `${contextPath}/api/getUsers`;
        const response2 = await axios.get(url2, { params: { search }, withCredentials: true });
        if (response2.status === 200) {
            if (Array.isArray(response2.data)) return response2.data.map(toMentionUser);
        }

        return [];
    } catch (err) {
        if (err.status === 401) {
            localStorage.removeItem('jwt');
            navigate('/login');
        }
        console.error('Fetch error:', err);
        return [];
    }
}

export const getUsersByEmail = async (email) => {
    try {
        // Check if running locally
        const isLocal = window.location.hostname === "localhost";
        const port = isLocal ? messages.node_server_port : "";
        const contextPath = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;
        
        // Call endpoint to get user details
        const url = `${contextPath}/api/users/byEmail`;
        const response = await axios.get(url, { 
            params: { email: email }, 
            withCredentials: true 
        });

        if (response.status === 200 && response.data) {
            // Return user object with details
            const user = response.data;
            return {
                success: true,
                user: user,
                multifactorEnabled: user.multifactorEnabled === 'Yes' || user.multifactorEnabled === true,
                canAccessOrders: user.multifactorEnabled === 'Yes' || user.multifactorEnabled === true,
                poValidationAccess: user.poValidationAccess === 'Yes' || user.poValidationAccess === true,
                username: user.username || user.email?.split('@')[0] || '',
                email: user.email || '',
                displayName: user.displayName || user.name || user.username || ''
            };
        }

        return {
            success: false,
            message: 'User not found',
            canAccessOrders: false
        };
    } catch (err) {
        if (err.response?.status === 401) {
            localStorage.removeItem('jwt');
            // Redirect to login
            window.location.href = '/login';
        }
        console.error('Fetch user by email error:', {
            message: err.message,
            response: err.response?.data,
            status: err.response?.status
        });
        return {
            success: false,
            message: err.response?.data?.message || err.message || 'Error fetching user',
            canAccessOrders: false
        };
    }
};

// export const saveComment = async(comments)=>{
//     try {
//         debugger
//         const contextPath = `${window.location.protocol}//${window.location.hostname}`;
//         const url = `${contextPath}/api/saveComments`;
//         //const data = await axios.post(url,comments);
//         const data = await axios.post(
//             url,comments,
//             {
//               headers: {
//                 "Content-Type": "application/json",
//               },
//             }
//           );
//         if(data.status === 200)
//             return data.data;
//         else
//             return null;

//     } catch (error) {
        
//     }
// }

export const saveComment = async (comments) => {
    try {
        //console.log("Sending comments:", comments); // Debugging
        // Check if running locally
    const isLocal = window.location.hostname === "localhost";

    // Get port from config for local, empty for production
    const port = isLocal ? messages.node_server_port : "";

    // Build the base URL
    const contextPath = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;
        // const contextPath = `${window.location.protocol}//${window.location.hostname}:${messages.node_server_port}`;
        const url = `${contextPath}/api/saveComments`;

        const response = await axios.post(url, comments, {
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
        });

        if (response.status === 200) return response.data;
        return null;
    } catch (err) {
        if(err.status === 401){
                localStorage.removeItem('jwt');
                navigate('/login');
            }
            console.error("Fetch error:", err);
    }
};


export const saveLineStatus = async (comments) => {
    try {
        console.group('%c🚀 [saveLineStatus] Starting line status save', 'color: #FF6B35; font-weight: bold; font-size: 12px');
        console.log('Payload:', comments);
        
        // Check if running locally
        const isLocal = window.location.hostname === "localhost";
        console.log('Is Local?:', isLocal);

        // Get port from config for local, empty for production
        const port = isLocal ? messages.node_server_port : "";
        console.log('Port configured:', port);

        // Build the base URL
        const contextPath = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;
        const url = `${contextPath}/api/saveOrderLineStatus`;
        console.log('Full URL:', url);

        // Default the author when the caller did not supply one. Names the user on the order
        // history entry and on the ENG Review notification raised for the review departments.
        const payload = {
            ...comments,
            lastEditedBy: comments?.lastEditedBy
                || localStorage.getItem('userEmail')
                || localStorage.getItem('email')
                || localStorage.getItem('userName')
                || ''
        };

        console.log('%c📤 Sending POST request...', 'color: #4AB2D5; font-weight: bold');
        const response = await axios.post(url, payload, {
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
            timeout: 15000 // 15 second timeout
        });

        console.log('%c✅ Success! Response status:', 'color: #28a745; font-weight: bold', response.status);
        console.log('Response data:', response.data);
        console.groupEnd();
        
        if (response.status === 200) return response.data;
        return null;
    } catch (err) {
        console.group('%c❌ [saveLineStatus] ERROR CAUGHT', 'color: #EB4F4F; font-weight: bold; font-size: 12px');
        console.error('Error message:', err.message);
        console.error('Response status:', err.response?.status);
        console.error('Response data:', err.response?.data);
        console.error('Request URL:', err.config?.url);
        console.error('Request headers:', err.config?.headers);
        console.error('Full error object:', err);
        console.groupEnd();
        
        if(err.response?.status === 401){
            localStorage.removeItem('jwt');
            window.location.href = '/login';
        }
        
        return null; // Return null instead of throwing
    }
};

export const saveQuoteLineStatus = async (data) => {
    try {
        const isLocal = window.location.hostname === "localhost";
        const port = isLocal ? messages.node_server_port : "";
        const contextPath = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;
        const url = `${contextPath}/api/saveQuoteLineStatus`;

        const response = await axios.post(url, data, {
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
            timeout: 15000
        });

        if (response.status === 200) return response.data;
        return null;
    } catch (err) {
        if (err.status === 401) {
            localStorage.removeItem('jwt');
            navigate('/login');
        }
        console.error("Fetch error:", err);
        return null;
    }
};

export const savePOLineStatus = async (poLineData) => {
    try {
        const isLocal = window.location.hostname === "localhost";
        const port = isLocal ? messages.node_server_port : "";
        const contextPath = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;
        const url = `${contextPath}/api/savePOLineStatus`;

        const response = await axios.post(url, poLineData, {
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
        });

        if (response.status === 200) return response.data;
        return null;
    } catch (err) {
        if(err.status === 401){
            localStorage.removeItem('jwt');
            navigate('/login');
        }
        console.error("Fetch error:", err);
        throw err;
    }
};

// Save PO Line Tags via API
export const savePOLineTag = async (poLineData) => {
    try {
        const isLocal = window.location.hostname === "localhost";
        const port = isLocal ? messages.node_server_port : "";
        const contextPath = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;
        const url = `${contextPath}/api/savePOLineTag`;

        const response = await axios.post(url, poLineData, {
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
        });

        if (response.status === 200) return response.data;
        return null;
    } catch (err) {
        if(err.status === 401){
            localStorage.removeItem('jwt');
            navigate('/login');
        }
        console.error("Fetch error:", err);
        throw err;
    }
};

// Add this function to your CommonContex.js or API file
export const updateOrderAccessLink = async (data) => {
    try {
        debugger
        // Check if running locally
        const isLocal = window.location.hostname === "localhost";

        // Get port from config for local, empty for production
        const port = isLocal ? messages.node_server_port : "";

        // Build the base URL
        const contextPath = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;
        const url = `${contextPath}/api/saveOrdersFolderUrl`;

        const response = await axios.post(url, data, {
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
        });

        if (response.status === 200) return response.data;
        return null;
    } catch (err) {
        if(err.status === 401){
            localStorage.removeItem('jwt');
            navigate('/login');
        }
        console.error("Fetch error:", err);
        throw err; // Re-throw to handle in the calling function
    }
};

// Save PO Folder URL via API
export const savePOFolderUrl = async (data) => {
    try {
        // Check if running locally
        const isLocal = window.location.hostname === "localhost";

        // Get port from config for local, empty for production
        const port = isLocal ? messages.node_server_port : "";

        // Build the base URL
        const contextPath = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;
        const url = `${contextPath}/api/savePOFolderUrl`;

        const response = await axios.post(url, data, {
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
        });

        if (response.status === 200) return response.data;
        return null;
    } catch (err) {
        if(err.status === 401){
            localStorage.removeItem('jwt');
            navigate('/login');
        }
        console.error("Fetch error:", err);
        throw err; // Re-throw to handle in the calling function
    }
};

// Manage Order URLs (add/delete)
export const manageOrderUrl = async (data) => {
    try {
        debugger
        // Check if running locally
        const isLocal = window.location.hostname === "localhost";

        // Get port from config for local, empty for production
        const port = isLocal ? messages.node_server_port : "";

        // Build the base URL
        const contextPath = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;
        const url = `${contextPath}/api/orders/urls/manage`;

        const response = await axios.post(url, data, {
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
        });

        if (response.status === 200 || response.status === 201) return response.data;
        return null;
    } catch (err) {
        if(err.status === 401){
            localStorage.removeItem('jwt');
            navigate('/login');
        }
        console.error("Fetch error:", err);
        throw err; // Re-throw to handle in the calling function
    }
};

// Customer Drawing Change Request (CDCR) - calls Node backend which proxies to Spring Boot /api/cdcr
const cdcrRequest = async (method, path, { data, params } = {}) => {
    const isLocal = window.location.hostname === "localhost";
    const port = isLocal ? messages.node_server_port : "";
    const contextPath = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;
    try {
        const response = await axios({
            method,
            url: `${contextPath}/api/cdcr${path}`,
            data,
            params,
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
        });
        return response.data;
    } catch (err) {
        if (err.status === 401) {
            localStorage.removeItem('jwt');
            navigate('/login');
        }
        console.error("CDCR request error:", err);
        throw err;
    }
};

const cdcrUser = () => localStorage.getItem('userName') || localStorage.getItem('userEmail') || '';

export const getCdcrsByOrderLine = (orderLineId) =>
    cdcrRequest('get', `/line/${encodeURIComponent(orderLineId)}`);

export const getCdcrPrefill = (orderLineId) =>
    cdcrRequest('get', `/line/${encodeURIComponent(orderLineId)}/prefill`, { params: { user: cdcrUser() } });

export const saveCdcr = (cdcr) => (cdcr.id
    ? cdcrRequest('put', `/${cdcr.id}`, { data: cdcr, params: { user: cdcrUser() } })
    : cdcrRequest('post', '', { data: cdcr, params: { user: cdcrUser() } }));

export const deleteCdcr = (id) => cdcrRequest('delete', `/${id}`);

// Manage Purchase Order URLs (add/delete) - calls Node backend which proxies to Spring Boot
export const managePurchaseOrderUrl = async (data) => {
    try {
        debugger
        // Check if running locally
        const isLocal = window.location.hostname === "localhost";

        // Get port from config for local, empty for production
        const port = isLocal ? messages.node_server_port : "";

        // Build the base URL - calls Node backend at port 8085
        const contextPath = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;
        const url = `${contextPath}/api/po/urls/manage`;

        const response = await axios.post(url, data, {
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
        });

        if (response.status === 200 || response.status === 201) return response.data;
        return null;
    } catch (err) {
        if(err.status === 401){
            localStorage.removeItem('jwt');
            navigate('/login');
        }
        console.error("Fetch error:", err);
        throw err; // Re-throw to handle in the calling function
    }
};

// Manage Quote URLs (add/delete) - calls Node backend which proxies to Spring Boot
export const manageQuoteUrl = async (data) => {
    try {
        const isLocal = window.location.hostname === "localhost";
        const port = isLocal ? messages.node_server_port : "";
        const contextPath = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;
        const url = `${contextPath}/api/quotes/urls/manage`;

        const response = await axios.post(url, data, {
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
        });

        if (response.status === 200 || response.status === 201) return response.data;
        return null;
    } catch (err) {
        if (err.status === 401) {
            localStorage.removeItem('jwt');
            navigate('/login');
        }
        console.error("Fetch error:", err);
        throw err;
    }
};

export const getRefreshHistory = async () => {
    try {
        debugger
        // Check if running locally
        const isLocal = window.location.hostname === "localhost";

        // Get port from config for local, empty for production
        const port = isLocal ? messages.node_server_port : "";

        // Build the base URL
        const contextPath = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;
        const url = `${contextPath}/api/fetchTodayRefreshData`;

        const response = await axios.get(url, {
            withCredentials: true,
        });

        if (response.status === 200) return response.data;
        return null;
    } catch (err) {
        if(err.status === 401){
            localStorage.removeItem('jwt');
            navigate('/login');
        }
        console.error("Fetch error:", err);
        return null;
    }
};

export const getPORefreshHistory = async () => {
    try {
        const isLocal = window.location.hostname === "localhost";
        const port = isLocal ? messages.node_server_port : "";
        const contextPath = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;
        const url = `${contextPath}/api/fetchTodayPORefreshData`;
        console.log('🔄 [getPORefreshHistory] Calling API:', url);

        const response = await axios.get(url, {
            withCredentials: true,
        });

        console.log('✅ [getPORefreshHistory] API response status:', response.status);
        console.log('✅ [getPORefreshHistory] API response data:', response.data);
        if (response.status === 200) {
            console.log('✅ [getPORefreshHistory] Success - returning data');
            return response.data;
        }
        console.log('⚠️ [getPORefreshHistory] Unexpected status:', response.status);
        return null;
    } catch (err) {
        console.error('❌ [getPORefreshHistory] Error fetching PO refresh history:', err?.message || err);
        if(err.status === 401){
            localStorage.removeItem('jwt');
            navigate('/login');
        }
        console.error("Fetch error:", err);
        return null;
    }
};

export const getQuoteRefreshHistory = async () => {
    try {
        const isLocal = window.location.hostname === "localhost";
        const port = isLocal ? messages.node_server_port : "";
        const contextPath = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;
        const url = `${contextPath}/api/fetchTodayQuoteRefreshData`;
        console.log('🔄 [getQuoteRefreshHistory] Calling API:', url);

        const response = await axios.get(url, {
            withCredentials: true,
        });

        console.log('✅ [getQuoteRefreshHistory] API response status:', response.status);
        console.log('✅ [getQuoteRefreshHistory] API response data:', response.data);
        if (response.status === 200) {
            console.log('✅ [getQuoteRefreshHistory] Success - returning data');
            return response.data;
        }
        console.log('⚠️ [getQuoteRefreshHistory] Unexpected status:', response.status);
        return null;
    } catch (err) {
        console.error('❌ [getQuoteRefreshHistory] Error fetching Quote refresh history:', err?.message || err);
        if(err.status === 401){
            localStorage.removeItem('jwt');
            navigate('/login');
        }
        console.error("Fetch error:", err);
        return null;
    }
};

export const saveQuoteComment = async (comments) => {
    try {
        //console.log("Sending comments:", comments); // Debugging
        // Check if running locally
    const isLocal = window.location.hostname === "localhost";

    // Get port from config for local, empty for production
    const port = isLocal ? messages.node_server_port : "";

    // Build the base URL
    const contextPath = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;
        // const contextPath = `${window.location.protocol}//${window.location.hostname}:${messages.node_server_port}`;
        const url = `${contextPath}/api/saveQuoteComment`;

        const response = await axios.post(url, comments, {
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
        });

        if (response.status === 200) return response.data;
        return null;
    } catch (err) {
        if(err.status === 401){
                localStorage.removeItem('jwt');
                navigate('/login');
            }
            console.error("Fetch error:", err);
    }
};

export const savePOComment = async (comments) => {
    try {
        //console.log("Sending comments:", comments); // Debugging
        debugger
        // Check if running locally
    const isLocal = window.location.hostname === "localhost";

    // Get port from config for local, empty for production
    const port = isLocal ? messages.node_server_port : "";

    // Build the base URL
    const contextPath = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;
        // const contextPath = `${window.location.protocol}//${window.location.hostname}:${messages.node_server_port}`;
        const url = `${contextPath}/api/savePOComment`;

        const response = await axios.post(url, comments, {
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
        });

        if (response.status === 200) return response.data;
        return null;
    } catch (err) {
        if(err.status === 401){
                localStorage.removeItem('jwt');
                navigate('/login');
            }
            console.error("Fetch error:", err);
    }
};

export const fetchMeetingHighlight =async(index,maxRcords,search=null) =>{
    try {
        debugger
        // Check if running locally
    const isLocal = window.location.hostname === "localhost";

    // Get port from config for local, empty for production
    const port = isLocal ? messages.node_server_port : "";

    // Build the base URL
    const contextPath = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;
        // const contextPath = `${window.location.protocol}//${window.location.hostname}:${messages.node_server_port}`;
        const url = `${contextPath}/api/fetchMeetingHighlight`;
        const data = await axios.get(url,{
            params: {index,maxRcords,search },
            withCredentials: true,
        });
        if(data.status === 200)
            return data.data;
        else
            return null;

    } catch (err) {
        if(err.status === 401){
                localStorage.removeItem('jwt');
                navigate('/login');
            }
            console.error("Fetch error:", err);
    }
};

export const saveMeetingHighlight = async (meeting) => {
    try {
        //console.log("Sending comments:", comments); // Debugging
        debugger
        // Check if running locally
    const isLocal = window.location.hostname === "localhost";

    // Get port from config for local, empty for production
    const port = isLocal ? messages.node_server_port : "";

    // Build the base URL
    const contextPath = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;
        // const contextPath = `${window.location.protocol}//${window.location.hostname}:${messages.node_server_port}`;
        const url = `${contextPath}/api/saveMeetingHighlight`;

        const response = await axios.post(url, meeting, {
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
        });

        if (response.status === 200) return response.data;
        return null;
    } catch (err) {
        if(err.status === 401){
                localStorage.removeItem('jwt');
                navigate('/login');
            }
            console.error("Fetch error:", err);
    }
};

export const checkToken = async () => {

      try {
        // Check if running locally
    const isLocal = window.location.hostname === "localhost";

    // Get port from config for local, empty for production
    const port = isLocal ? messages.node_server_port : "";

    // Build the base URL
    const contextPath = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;
        //  const contextPath = `${window.location.protocol}//${window.location.hostname}:${messages.node_server_port}`;
        const url = `${contextPath}/api/validateToken`;
        const response = await axios.get(url, {
          withCredentials: true,
        });

        if (response.data.valid) {
          return true;
        } else {
          return false;
        }
      } catch (error) {
        return false;
      }
    };


// CommonContex.js
export const featchInvoices = async (index = "0", maxRecords = "10", searchTerm = null) => {
    try {
        // Check if running locally
    const isLocal = window.location.hostname === "localhost";

    // Get port from config for local, empty for production
    const port = isLocal ? messages.node_server_port : "";

    // Build the base URL
    const contextPath = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;
        // const contextPath = `${window.location.protocol}//${window.location.hostname}:${messages.node_server_port}`;
        const url = `${contextPath}/api/fetchInvoices`;
        const token = localStorage.getItem('jwt');
        
        const response = await axios.get(url, {
            params: { index, maxRecords, searchTerm },
            headers: { Authorization: `Bearer ${token}` },
            withCredentials: true
        });

        if (response.status === 200) {
            return response.data;
        }
        return null;
    } catch (err) {
        console.error("Fetch error:", err);
        throw err; // Throw the error to be handled by the component
    }
}

export const fetchQuotes = async (index = "0", maxRecords = "10", searchTerm = null) => {
    try {
        // Check if running locally
    const isLocal = window.location.hostname === "localhost";

    // Get port from config for local, empty for production
    const port = isLocal ? messages.node_server_port : "";

    // Build the base URL
    const contextPath = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;
        // const contextPath = `${window.location.protocol}//${window.location.hostname}:${messages.node_server_port}`;
        const url = `${contextPath}/api/fetchQuotes`;
        const token = localStorage.getItem('jwt');
        
        const response = await axios.get(url, {
            params: { index, maxRecords, searchTerm },
            headers: { Authorization: `Bearer ${token}` },
            withCredentials: true
        });

        if (response.status === 200) {
            return response.data;
        }
        return null;
    } catch (err) {
        console.error("Fetch error:", err);
        throw err; // Throw the error to be handled by the component
    }



}

export const fetchQuoteById = async (quoteId) => {
    try {
        const isLocal = window.location.hostname === "localhost";
        const port = isLocal ? messages.node_server_port : "";
        const contextPath = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;
        const url = `${contextPath}/api/getQuoteById/${quoteId}`;
        const token = localStorage.getItem('jwt');

        const response = await axios.get(url, {
            headers: { Authorization: `Bearer ${token}` },
            withCredentials: true
        });

        if (response.status === 200) {
            return response.data;
        }
        return null;
    } catch (err) {
        console.error("Fetch error:", err);
        throw err;
    }
}

export const syncQuotes = async (user) => {
    try {
        //console.log("Sending comments:", comments); // Debugging
        // Check if running locally
    const isLocal = window.location.hostname === "localhost";

    // Get port from config for local, empty for production
    const port = isLocal ? messages.node_server_port : "";

    // Build the base URL
    const contextPath = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;
        // const contextPath = `${window.location.protocol}//${window.location.hostname}:${messages.node_server_port}`;
        const url = `${contextPath}/api/syncQuotes`;
        const token = localStorage.getItem('site');

        const response = await axios.post(url, user, {
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
        });

        if (response.status === 200) return response.data;
        return null;
    } catch (err) {
        if(err.status === 401){
                localStorage.removeItem('jwt');
                navigate('/login');
            }
            console.error("Fetch error:", err);
    }
};


export const syncOrders = async (user) => {
    try {
        //console.log("Sending comments:", comments); // Debugging
        // Check if running locally
        debugger
    const isLocal = window.location.hostname === "localhost";

    // Get port from config for local, empty for production
    const port = isLocal ? messages.node_server_port : "";

    // Build the base URL
    const contextPath = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;
        // const contextPath = `${window.location.protocol}//${window.location.hostname}:${messages.node_server_port}`;
        const url = `${contextPath}/api/syncOrders`;
        const token = localStorage.getItem('site');

        const response = await axios.post(url, user, {
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
        });

        if (response.status === 200) return response.data;
        return null;
    } catch (err) {
        if(err.status === 401){
                localStorage.removeItem('jwt');
                navigate('/login');
            }
            console.error("Fetch error:", err);
    }
};

export const syncPO = async (user) => {
    try {
        const isLocal = window.location.hostname === "localhost";
        const port = isLocal ? messages.node_server_port : "";
        const contextPath = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;
        const url = `${contextPath}/api/syncPO`;
        console.log('[syncPO] Calling:', url, 'payload:', user);

        const response = await axios.post(url, user, {
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
        });

        console.log('[syncPO] Response status:', response.status);
        if (response.status === 200) return response.data;
        throw new Error(`syncPO failed with status ${response.status}`);
    } catch (err) {
        if(err.status === 401){
                localStorage.removeItem('jwt');
                navigate('/login');
            }
            console.error("[syncPO] Fetch error:", err);
            throw err;
    }
};

export const deleteComment = async(commentId,orderLineId) => {
    try {
        const body ={
            commentId:commentId,
            orderLineId:orderLineId
        }
        // Check if running locally
    const isLocal = window.location.hostname === "localhost";

    // Get port from config for local, empty for production
    const port = isLocal ? messages.node_server_port : "";

    // Build the base URL
    const contextPath = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;
        // const contextPath = `${window.location.protocol}//${window.location.hostname}:${messages.node_server_port}`;
        const url = `${contextPath}/api/deleteComment`;

        const response = await axios.post(url, body, {
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
        });

        if (response.status === 200) return response.data;
        return null;
    } catch (err) {
        if(err.status === 401){
                localStorage.removeItem('jwt');
                navigate('/login');
            }
            console.error("Fetch error:", err);
    }
};

export const getOrderHistory = async (ordernum) => {
    try {
        const isLocal = window.location.hostname === "localhost";
        const port = isLocal ? messages.node_server_port : "";
        const contextPath = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;
        const url = `${contextPath}/api/order-history/${ordernum}`;

        const response = await axios.get(url, {
            withCredentials: true,
        });

        if (response.status === 200) {
            // Apply Order Access hints first so real add/update/remove rows are upgraded,
            // then drop leftover boolean workflow rows (Confirm & Move / Review / Ready).
            return dropUnmatchedBooleanWorkflowHistory(
                applyOrderAccessHistoryHints(
                    filterOrderHistoryEntries(response.data),
                    { ordernum: String(ordernum || '').trim() }
                )
            );
        }
        return [];
    } catch (err) {
        if (err.status === 401) {
            localStorage.removeItem('jwt');
            navigate('/login');
        }
        console.error("Fetch error:", err);
        return [];
    }
};

export const getAllOrdersHistory = async (page = 0, size = 50) => {
    try {
        const isLocal = window.location.hostname === "localhost";
        const port = isLocal ? messages.node_server_port : "";
        const contextPath = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;
        const url = `${contextPath}/api/order-history`;

        const response = await axios.get(url, {
            params: { page, size },
            withCredentials: true,
        });

        if (response.status === 200) {
            const data = response.data;
            if (data && Array.isArray(data.content)) {
                const filtered = filterOrderHistoryEntries(data.content);
                const ordernums = [
                    ...new Set(
                        filtered
                            .map((e) => String(e?.ordernum || '').trim())
                            .filter(Boolean)
                    ),
                ];
                return {
                    ...data,
                    content: dropUnmatchedBooleanWorkflowHistory(
                        applyOrderAccessHistoryHints(filtered, { ordernums })
                    ),
                };
            }
            return data;
        }
        return { content: [], totalElements: 0, totalPages: 0 };
    } catch (err) {
        if (err.status === 401) {
            localStorage.removeItem('jwt');
            navigate('/login');
        }
        console.error("Fetch error:", err);
        return { content: [], totalElements: 0, totalPages: 0 };
    }
};

export const deleteQuoteComment = async(commentId, quoteId) => {
    try {
        const body = {
            id: commentId,
            commentId: commentId,
            quoteId: quoteId,
            quotesId: quoteId
        };
        // Check if running locally
    const isLocal = window.location.hostname === "localhost";

    // Get port from config for local, empty for production
    const port = isLocal ? messages.node_server_port : "";

    // Build the base URL
    const contextPath = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;
        const url = `${contextPath}/api/deleteQuoteComment`;

        const response = await axios.post(url, body, {
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
        });

        if (response.status === 200) return response.data;
        return null;
    } catch (err) {
        if(err.status === 401){
                localStorage.removeItem('jwt');
                navigate('/login');
            }
            console.error("Fetch error:", err);
            throw err;
    }
};

export const deletePOComment = async(commentId,orderLineId) => {
    try {
        //console.log("Sending comments:", comments); // Debugging
        debugger
        const body ={
            commentId:commentId,
            poLineId:orderLineId
        }
        // Check if running locally
    const isLocal = window.location.hostname === "localhost";

    // Get port from config for local, empty for production
    const port = isLocal ? messages.node_server_port : "";

    // Build the base URL
    const contextPath = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;
        // const contextPath = `${window.location.protocol}//${window.location.hostname}:${messages.node_server_port}`;
        const url = `${contextPath}/api/deletePOComment`;

        const response = await axios.post(url, body, {
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
        });

        if (response.status === 200) return response.data;
        return null;
    } catch (err) {
        if(err.status === 401){
                localStorage.removeItem('jwt');
                navigate('/login');
            }
            console.error("Fetch error:", err);
    }
};

// Notifications
// `rethrow` lets the notifications poller keep what it already has when a fetch fails,
// instead of treating a network error as "no notifications".
export const fetchNotifications = async (email, { rethrow = false } = {}) => {
    try {
        const isLocal = window.location.hostname === "localhost";
        const port = isLocal ? messages.node_server_port : "";
        const contextPath = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;
        const encoded = encodeURIComponent(email);
        const url = `${contextPath}/api/notifications/${encoded}`;
        const response = await axios.get(url, { withCredentials: true });
        if (response.status === 200 && Array.isArray(response.data)) {
            return response.data;
        }
        return [];
    } catch (err) {
        if (err.status === 401) {
            localStorage.removeItem('jwt');
            navigate('/login');
        }
        console.error('Fetch error:', err);
        if (rethrow) throw err;
        return [];
    }
};

// Mark notification as read
export const markNotificationRead = async (notificationId) => {
    try {
        const isLocal = window.location.hostname === "localhost";
        const port = isLocal ? messages.node_server_port : "";
        const contextPath = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;
        const url = `${contextPath}/api/notifications/mark-read/${notificationId}`;
        const response = await axios.post(url, {}, { withCredentials: true });
        if (response.status === 200) {
            return { success: true, data: response.data };
        }
        return { success: false };
    } catch (err) {
        if (err.status === 401) {
            localStorage.removeItem('jwt');
            navigate('/login');
        }
        console.error('Mark read error:', err);
        return { success: false };
    }
};

// Send Teams notification when comment is added
export const sendTeamsNotification = async (commentData) => {
    try {
        const isLocal = window.location.hostname === "localhost";
        const port = isLocal ? messages.node_server_port : "";
        const contextPath = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;
        const url = `${contextPath}/api/sendTeamsNotification`;
        
        const response = await axios.post(url, commentData, {
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
        });

        if (response.status === 200) {
            console.log('Teams notification sent successfully');
            return { success: true };
        }
        return { success: false };
    } catch (err) {
        console.error('Teams notification error:', err);
        return { success: false };
    }
};

// Sticky notes: permanent order / shipping instructions shown in the Orders grid.
// These rethrow so the sticky-notes store can tell "endpoint not deployed yet" (404)
// apart from a real failure. See docs/sticky-notes-and-comment-chats.md for the contract.
const stickyNotesUrl = (suffix = '') => {
    const isLocal = window.location.hostname === "localhost";
    const port = isLocal ? messages.node_server_port : "";
    const contextPath = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;
    return `${contextPath}/api/stickyNotes${suffix}`;
};

const handleStickyNotesError = (err) => {
    if (err?.status === 401 || err?.response?.status === 401) {
        localStorage.removeItem('jwt');
        navigate('/login');
    }
    throw err;
};

export const fetchStickyNotes = async (orderNumbers) => {
    try {
        const response = await axios.get(stickyNotesUrl(), {
            params: { orderNumbers: (orderNumbers || []).join(',') },
            withCredentials: true,
        });
        return response.data;
    } catch (err) {
        return handleStickyNotesError(err);
    }
};

export const createStickyNote = async (note) => {
    try {
        const response = await axios.post(stickyNotesUrl(), note, {
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
        });
        return response.data;
    } catch (err) {
        return handleStickyNotesError(err);
    }
};

export const updateStickyNote = async (id, changes) => {
    try {
        const response = await axios.put(stickyNotesUrl(`/${encodeURIComponent(id)}`), changes, {
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
        });
        return response.data;
    } catch (err) {
        return handleStickyNotesError(err);
    }
};

export const deleteStickyNote = async (id) => {
    try {
        const response = await axios.delete(stickyNotesUrl(`/${encodeURIComponent(id)}`), {
            withCredentials: true,
        });
        return response.data;
    } catch (err) {
        return handleStickyNotesError(err);
    }
};

/**
 * Cetec shipping instructions for the given customers, read-only, grouped by
 * customer id: `{ [customerId]: [{ addressId, addressType, name, instructions }] }`.
 * Customers with no instructions are absent. A missing endpoint (not deployed yet)
 * is treated as "no instructions" so the sticky notes keep working.
 */
export const fetchShippingInstructions = async (customerIds) => {
    const isLocal = window.location.hostname === "localhost";
    const port = isLocal ? messages.node_server_port : "";
    const contextPath = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;
    try {
        const response = await axios.get(`${contextPath}/api/customers/shipping-instructions`, {
            params: { customerIds: (customerIds || []).join(',') },
            withCredentials: true,
        });
        const data = response.data;
        return data && typeof data === 'object' && !Array.isArray(data) ? data : {};
    } catch (err) {
        const status = err?.response?.status;
        if (status === 404 || status === 405 || status === 501) return {};
        return handleStickyNotesError(err);
    }
};

const shippingNotesUrl = (suffix) => {
    const isLocal = window.location.hostname === "localhost";
    const port = isLocal ? messages.node_server_port : "";
    const contextPath = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;
    return `${contextPath}/api/customers${suffix}`;
};

/** Add a user-written shipping instruction for a whole customer. */
export const createShippingNote = async (customerId, note) => {
    try {
        const response = await axios.post(
            shippingNotesUrl(`/${encodeURIComponent(customerId)}/shipping-notes`),
            note,
            { headers: { "Content-Type": "application/json" }, withCredentials: true }
        );
        return response.data;
    } catch (err) {
        return handleStickyNotesError(err);
    }
};

export const updateShippingNote = async (noteId, changes) => {
    try {
        const response = await axios.put(
            shippingNotesUrl(`/shipping-notes/${encodeURIComponent(noteId)}`),
            changes,
            { headers: { "Content-Type": "application/json" }, withCredentials: true }
        );
        return response.data;
    } catch (err) {
        return handleStickyNotesError(err);
    }
};

export const deleteShippingNote = async (noteId) => {
    try {
        await axios.delete(shippingNotesUrl(`/shipping-notes/${encodeURIComponent(noteId)}`), {
            withCredentials: true,
        });
    } catch (err) {
        return handleStickyNotesError(err);
    }
};

// Push Notifications: get VAPID public key
export const getVapidPublicKey = async () => {
    try {
        const isLocal = window.location.hostname === "localhost";
        const port = isLocal ? messages.node_server_port : "";
        const contextPath = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;
        const url = `${contextPath}/api/notifications/push/vapid-public-key`;
        const response = await axios.get(url, { withCredentials: true });
        if (response.status === 200 && response.data) {
            return { success: true, data: response.data };
        }
        return { success: false };
    } catch (err) {
        if (err.status === 401) {
            localStorage.removeItem('jwt');
            navigate('/login');
        }
        console.error('VAPID key fetch error:', err);
        return { success: false, error: err.message };
    }
};

// Push Notifications: subscribe
export const pushSubscribe = async (username, subscription) => {
    try {
        const isLocal = window.location.hostname === "localhost";
        const port = isLocal ? messages.node_server_port : "";
        const contextPath = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;
        const url = `${contextPath}/api/notifications/push/subscribe`;
        const response = await axios.post(url, { username, subscription }, {
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
        });
        if (response.status === 200) {
            return { success: true, data: response.data };
        }
        return { success: false };
    } catch (err) {
        if (err.status === 401) {
            localStorage.removeItem('jwt');
            navigate('/login');
        }
        console.error('Push subscribe error:', err);
        return { success: false, error: err.message };
    }
};

// Push Notifications: unsubscribe
export const pushUnsubscribe = async (username, endpoint) => {
    try {
        const isLocal = window.location.hostname === "localhost";
        const port = isLocal ? messages.node_server_port : "";
        const contextPath = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;
        const encoded = encodeURIComponent(username);
        const url = `${contextPath}/api/notifications/push/unsubscribe/${encoded}`;
        const response = await axios.post(url, { endpoint }, {
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
        });
        if (response.status === 200) {
            return { success: true, data: response.data };
        }
        return { success: false };
    } catch (err) {
        if (err.status === 401) {
            localStorage.removeItem('jwt');
            navigate('/login');
        }
        console.error('Push unsubscribe error:', err);
        return { success: false, error: err.message };
    }
};

// Push Notifications: test send
export const pushTestSend = async (username) => {
    try {
        const isLocal = window.location.hostname === "localhost";
        const port = isLocal ? messages.node_server_port : "";
        const contextPath = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;
        const encoded = encodeURIComponent(username);
        const url = `${contextPath}/api/notifications/push/test-send/${encoded}`;
        const response = await axios.post(url, {}, { withCredentials: true });
        if (response.status === 200) {
            return { success: true, data: response.data };
        }
        return { success: false };
    } catch (err) {
        if (err.status === 401) {
            localStorage.removeItem('jwt');
            navigate('/login');
        }
        console.error('Push test-send error:', err);
        return { success: false, error: err.message };
    }
};

// Push Notifications: subscription count
export const pushSubscriptionCount = async (username) => {
    try {
        const isLocal = window.location.hostname === "localhost";
        const port = isLocal ? messages.node_server_port : "";
        const contextPath = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;
        const encoded = encodeURIComponent(username);
        const url = `${contextPath}/api/notifications/push/subscription-count/${encoded}`;
        const response = await axios.get(url, { withCredentials: true });
        if (response.status === 200) {
            return { success: true, data: response.data };
        }
        return { success: false };
    } catch (err) {
        if (err.status === 401) {
            localStorage.removeItem('jwt');
            navigate('/login');
        }
        console.error('Push subscription-count error:', err);
        return { success: false, error: err.message };
    }
};